import DeliveryFor from './DeliveryFor';
import PickupFor from './PickupFor';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import React from 'react';


export default function OrderType(props: any) {
    const orderType = useSelector((state: any) => state.payment.orderType);
    const location = useLocation();
    const isStoreLocator = location.pathname === "/store-locations";

    return (
        <div>

            <div className={isStoreLocator ? 'disableds' : ''}>
                {
                    process.env.REACT_APP_DELIVERY_ENABLE == "true" && orderType == "Delivery" ?
                        <DeliveryFor />
                        :
                        <PickupFor />
                }
            </div>
        </div>
    )
}
